import { PublicConfigurationT } from "@swo/shared";

export function fetchConfiguration(): Promise<PublicConfigurationT> {
  return fetch(`/storefront/configuration`).then(res => res.json());
}
